import { IDealAttribute } from 'components/DealForm/types';
import { formatUSDCurrency, formatUSDCurrencyTwoDigits } from 'ns_libs/formatter';
import { COLUMN_OPTIONS } from '../constants';
import { Deal, IDealColumnOption } from '../types';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isCustomAttributeColumnId = (columnId: string): boolean => UUID_PATTERN.test(columnId);

const getCustomAttributeDisplayValue = (deal: Deal, attribute: IDealAttribute): string | null => {
    const value = deal.customAttributes?.find(item => item.attributeId === attribute.correlationId);
    if (!value) return null;

    switch (attribute.inputType) {
        case 'number':
            return value.valueNumber == null ? null : String(value.valueNumber);
        case 'amount':
            // Core hardcodes USD for amount attributes and stores no currency per attribute.
            if (value.valueNumber == null) return null;
            return Number.isInteger(value.valueNumber)
                ? formatUSDCurrency(value.valueNumber)
                : formatUSDCurrencyTwoDigits(value.valueNumber);
        case 'select':
            return value.valueSingleSelect || null;
        case 'multi_select':
            return value.valueMultiSelect?.length ? value.valueMultiSelect.join(', ') : null;
        default:
            return value.valueText || null;
    }
};

export const buildCustomAttributeColumnOptions = (attributes: IDealAttribute[] | undefined): IDealColumnOption[] => (
    (attributes ?? [])
        .filter(attribute => attribute.isCustom)
        .map(attribute => ({
            label: attribute.name,
            value: attribute.correlationId,
            sortable: true,
            cellRenderer: (deal: Deal) => <span>{getCustomAttributeDisplayValue(deal, attribute) ?? '-'}</span>,
        }))
);

export const buildDealColumnOptions = (attributes: IDealAttribute[] | undefined): IDealColumnOption[] => [
    ...COLUMN_OPTIONS,
    ...buildCustomAttributeColumnOptions(attributes),
];
